import { render, staticRenderFns } from "./SuppliersListDisplay.vue?vue&type=template&id=0d372689&scoped=true"
import script from "./SuppliersListDisplay.vue?vue&type=script&lang=ts"
export * from "./SuppliersListDisplay.vue?vue&type=script&lang=ts"
import style0 from "./SuppliersListDisplay.vue?vue&type=style&index=0&id=0d372689&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d372689",
  null
  
)

export default component.exports